import { createClient } from '@supabase/supabase-js';
import type { Database } from '@jeraisonne/db';
import { createFetchWithTimeout } from './fetch-with-timeout';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!url || !anonKey) {
  throw new Error('VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY sont requis.');
}

export const supabaseUrl = url;
export const supabaseAnonKey = anonKey;

export const supabase = createClient<Database>(url, anonKey, {
  // Délai d'expiration des requêtes courtes : sans lui, une requête bloquée
  // laissait une page en chargement sans fin (cf. fetch-with-timeout.ts).
  global: { fetch: createFetchWithTimeout() },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // `flowType` DOIT rester 'pkce' : le défaut de supabase-js est 'implicit',
    // qui renvoie les jetons dans le FRAGMENT de l'URL de retour
    // (`…#access_token=…`). Sur natif, ce fragment arrive dans le deep link
    // `fr.jeraisonne.app://auth-callback` — mais rien ne le lit (le webview ne
    // navigue pas), et `exchangeCodeForSession` n'a pas de code à échanger :
    // Google/Facebook ne connectaient donc JAMAIS sur mobile. En PKCE, Supabase
    // renvoie `?code=…`, que le listener `appUrlOpen` (main.tsx) échange contre
    // une session. Sur le web, `detectSessionInUrl` fait le même échange.
    flowType: 'pkce',
  },
});
